import { defineStore, storeToRefs } from "pinia";
import genToken from "@utils/generateToken";
import { deepCopy } from "@utils/toolBox";
import { useSurveyProfilesStore } from "@stores/survey/surveyProfiles";
import { useSurveyStore } from "@stores/survey/survey";

export const useProfileListStore = defineStore("profileList", () => {
  // imported stores
  const surveyStore = useSurveyStore();
  const { survey, isAiChatSurvey } = storeToRefs(surveyStore);
  const surveyProfilesStore = useSurveyProfilesStore();
  const { surveyProfiles, selectedProfile, selectedProfileIndex, countryOptions } = storeToRefs(surveyProfilesStore);

  const selectProfile = (index) => {
    selectedProfileIndex.value = index;
    selectedProfile.value = surveyProfiles.value?.at(index);
  };

  const duplicateProfile = (index) => {
    const profile = deepCopy(surveyProfiles.value.at(index));
    const duplicatedProfile = {
      ...profile,
      token: genToken(),
      name: `Copy of ${profile.name}`,
      n_current: 0,
      launched_at: null,
      loi_prediction: { min: 0, max: 0, avg: 0 },
      answered_questions: { min: 0, max: 0, avg: 0 },
    };
    surveyProfiles.value.splice(index + 1, 0, duplicatedProfile);
    selectProfile(index + 1);
  };

  const addProfile = () => {
    const newIndex = surveyProfiles.value.length;
    const newProfile = {
      name: `Profile ${newIndex + 1}`,
      token: genToken(),
      country: countryOptions.value[0].value || "",
      language: survey.value.locales[0].language,
      description: "",
      active: true,
      question_params: [],
      url_params: [],
      n_target: isAiChatSurvey.value ? 1 : 50,
      n_current: 0,
      answered_questions: { min: 0, max: 0, avg: 0 },
      loi_prediction: { min: 0, max: 0, avg: 0 },
      survey_id: survey.value.id,
    };
    surveyProfiles.value.splice(newIndex, 0, newProfile);
    selectedProfile.value = surveyProfiles.value?.at(newIndex);
    selectedProfileIndex.value = newIndex;
  };

  return {
    selectProfile,
    duplicateProfile,
    addProfile,
  };
});
